import { createContext, ReactNode, useMemo } from 'react';
import { ApiClient } from './ApiClient';
import { AppBridgeApiClient } from './AppBridgeApiClient';
import { FetchApiClient, readTokenFromUrl, TOKEN_STORAGE_KEY } from './FetchApiClient';

export const ApiContext = createContext<ApiClient | null>(null);

export interface ApiProviderProps {
  children: ReactNode;
  client?: ApiClient;
}

function isEmbedded(): boolean {
  if (typeof window === 'undefined') return false;
  return new URLSearchParams(window.location.search).has('host');
}

export function ApiProvider({ children, client }: ApiProviderProps): JSX.Element {
  const value = useMemo<ApiClient>(() => {
    if (client) return client;
    if (isEmbedded()) {
      return new AppBridgeApiClient();
    }
    return new FetchApiClient({
      getAuthToken: () => {
        const fromUrl = readTokenFromUrl();
        if (fromUrl) return fromUrl;
        return sessionStorage.getItem(TOKEN_STORAGE_KEY) ?? '';
      },
    });
  }, [client]);

  return <ApiContext.Provider value={value}>{children}</ApiContext.Provider>;
}
